import React, {Component} from 'react';

import {connect} from "react-redux";
import {PropTypes} from "prop-types";

import {bindActionCreators} from "redux";
import {
	getObjectLength,
	objectToQueryString,
	pushUrl,
	getNumberFormat,
	getSelectFormat
} from "../../../../utils/functions"

import {BASE_PATH, RESOURCE_FACET_NAME, RESOURCE_FACET_ORDER} from "../../../../wpconfig"

import * as func from "../../../../utils/functions";
import SelectBox from "../../../etc/SelectBox";

import * as Actions from "../../../../store/modules/resources";
import * as FActions from "../../../../store/modules/footer";

class ResourceFacet extends Component {
	constructor(props) {
		super(props);
	}

	argsInputTextEvnet = (event) => {
		const {dataActions} = this.props;
		let param = this.props.param;
		param[event.target.name] = event.target.value;
		dataActions.setResources({"param": param});
	}

	facetCheckChangeEvent = (event) => {
		if (event.target.type === "checkbox") {
			let param = this.props.param;
			if (event.target.checked) {
				if (param[event.target.name].indexOf(event.target.value) < 0) {
					param[event.target.name].push(event.target.value);
				}
			} else {
				if (param[event.target.name].indexOf(event.target.value) > -1) {
					param[event.target.name].splice(param[event.target.name].indexOf(event.target.value), 1);
				}
			}
			const {dataActions} = this.props;
			dataActions.setResources({"param": param});

			setTimeout(() => {
				func.getData("resources", this.props.param).then((response) => {
					this.props.dataActions.setResources(response);

					const url = objectToQueryString(this.props.param);
					pushUrl('검색', BASE_PATH + 'resources/?' + url, this.props.param);
				});
			}, 0);
		}
	}

	facetReset = (event) => {
		let param = this.props.param;
		Object.keys(this.props.param).map((key, i) => {
			if (!param[key] || param[key].length <= 0)
				return;
			if (key === 'records_per_page' || key === 'order' || key === 'orderby') {
			} else if (key === 'current_page') {
				param[key] = 1;
			} else if (Array.isArray(param[key])) {
				param[key] = [];
			} else {
				param[key] = "";
			}
		});

		const {dataActions} = this.props;
		dataActions.setResources({"param": param});
		func.getData("resources", this.props.param).then((response) => {
			this.props.dataActions.setResources(response);

			pushUrl('검색', BASE_PATH + 'resources/', null);
		});
	}

	facetChangeEvent = (event) => {
		let param = this.props.param;
		if (param[event.target.name].indexOf(event.target.value) < 0) {
			param[event.target.name].push(event.target.value);
		}
		const {dataActions} = this.props;
		dataActions.setResources({"param": param});

		func.getData("resources", param).then((response) => {
			this.props.dataActions.setResources(response);

			const url = objectToQueryString(param);
			pushUrl('검색', BASE_PATH + 'resources/?' + url, param);
		});
	}

	search = (event) => {
		func.getData("resources", this.props.param).then((response) => {
			this.props.dataActions.setResources(response);

			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + 'resources/?' + url, this.props.param);
		});
	}

	tabAction = (event) => {
		event.target.parentNode.classList.toggle('active');
	}

	morePopup = (type) => {
		this.props.fDataActions.setFooter({
			'isPopup1': !this.props.isPopup1,
			'type': type,
			'part' : 'resources'
		});
	}

	render() {
		const facets = getObjectLength(this.props.facet) > 0 ? RESOURCE_FACET_ORDER : [];
		const param = this.props.param;
		const totalRecords = this.props.totalRecords;

		return (
			<div className="left-side-group">
				<div className="d-flex align-items-center justify-content-between mb-28">
					<h3 className="con-title">패싯 검색</h3>
					<div className="d-flex">
						{/*<button type="button" className="btn-search-ui"><span className="icon icon-size-24 icon-plus-white" /></button>*/}
						{/*<button type="button" className="btn-search-ui ml-2"><span className="icon icon-size-24 icon-bookmark-white" /></button>*/}
						<button type="button" className="btn-search-ui ml-2" onClick={this.facetReset}><span
							className="icon icon-size-24 icon-refresh-white"/></button>
					</div>
				</div>
				{totalRecords > 0 &&
				<div className="">
					<div className="form-side-search border-none pt-0">
						<div className="form-title">결과내 검색</div>
						<div className="form-input">
							<div className="input-btn">
								<input type="text" name="sub_ks" value={param.sub_ks} onChange={this.argsInputTextEvnet}
								       className="form-control" autoComplete="off"/>
								<button type="button" className="btn-control" onClick={this.search}><span
									className="icon icon-size-24 icon-search-gray"/></button>
							</div>
						</div>
					</div>
				</div>
				}
				{this.props.facet && getObjectLength(this.props.facet) > 0 ?
					facets.map((fa, i) => {
						const facet = this.props.facet[fa];
						if (!facet)
							return;
						// if (facet.result.length <= 1)
						// 	return;
						if (fa === 'dept')
							facet.result = getSelectFormat(facet.result);
						return (
							<div key={i}>
								{fa === 'dept' ?
									<div className="form-side-search">
										<div className="form-title">학과 선택</div>
										<SelectBox
											name={fa}
											title="선택해주세요"
											isMulti
											onAdd={this.facetChangeEvent}
											onRemove={this.facetChangeEvent}
											OptionData={facet.result}
										/>
									</div>
									:
									<div className="form-side-search">
										<div className="form-tree-item active" onClick={this.tabAction}>
											<button type="button" className="btn-tree-nav">{RESOURCE_FACET_NAME[fa]}</button>
											<div className="detail-tree-item">
												<div className="vertical-checkbox-list mt-3">
													<div className="checkbox-group">
														<div className="checkbox-group-cell mb-2">
															{facet.result
																.slice() // 원본 배열을 수정하지 않도록 복사
																.sort((a, b) => {
																	if (fa === 'publish_year') {
																		return b.name.localeCompare(a.name);
																	}
																	return 0; // 다른 경우는 기존 순서 유지
																}).map((item, index) => {
																	const checked = this.props.param[fa].includes(item.name);
																if (fa !== 'registered_db' && index >= 5)
																	return;

																return (
																	<React.Fragment key={index}>
																		<div className="checkbox-group-cell mb-2" key={index}>
																			<div className="custom-control custom-checkbox">
																				<input id={fa + '_' + index} name={fa} type="checkbox"
																				       className="custom-control-input"
																				       checked={checked} onChange={this.facetCheckChangeEvent}
																				       value={item.name}/>
																				<label className="custom-control-label"
																				       htmlFor={fa + '_' + index}>{item.name} ({getNumberFormat(item.count)})</label>
																			</div>
																		</div>
																	</React.Fragment>
																)
															})}
														</div>
													</div>
													{(fa !== 'registered_db' && facet.result.length > 5) &&
													<div className="checkbox-more">
														<button type="button" className="btn-checkbox-more" onClick={() => this.morePopup(fa)}>
															<span className="icon icon-size-24 icon-plus-black mr-2 align-top"/>More
														</button>
													</div>
													}
												</div>
											</div>
										</div>
									</div>
								}
							</div>
						)
					})
					: ''
				}
			</div>
		)
	}
}

export default connect(
	(state) => ({
		facet: state.resources.facet ? state.resources.facet : {},
		param: state.resources.param ? state.resources.param : {},
		totalRecords: state.resources.totalRecords ? state.resources.totalRecords : 0,
		isPopup1: state.footer.isPopup1 ? state.footer.isPopup1 : false,
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(ResourceFacet)

ResourceFacet.propTypes = {
	param: PropTypes.object,
	facet: PropTypes.object,
};
